import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.period.change.list');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-period-change-list',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.period.change.list/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminPeriodChangeListComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = false;
    public rows: any[] = [];
    public filterStatus: string = '';
    public searchText: string = '';
    public selected: any = null;
    public uploadingApp: boolean = false;
    public uploadingComp: boolean = false;
    public pendingAppForm: any = null;

    public statusOptions: any[] = [
        { value: '', label: '전체' },
        { value: 'requested', label: '신청됨' },
        { value: 'form_sent', label: '신청서 발송' },
        { value: 'signed_received', label: '서명본 수신' },
        { value: 'completed', label: '완료' },
        { value: 'cancelled', label: '취소됨' },
    ];

    public statusBadgeClass(s: string): string {
        const base = 'inline-flex items-center rounded-md px-2 py-1 text-xs font-medium';
        if (s === 'requested') return `${base} bg-amber-100 text-amber-800`;
        if (s === 'form_sent') return `${base} bg-blue-100 text-blue-800`;
        if (s === 'signed_received') return `${base} bg-indigo-100 text-indigo-800`;
        if (s === 'completed') return `${base} bg-emerald-100 text-emerald-800`;
        if (s === 'cancelled') return `${base} bg-rose-100 text-rose-700`;
        return `${base} bg-zinc-100 text-zinc-700`;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership(['admin', 'super_admin'], "/landing");
        await this.load();
    }

    public async load() {
        if (this.loading) return;
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("search", {
            text: this.searchText || '',
            status: this.filterStatus || ''
        });
        if (code === 200) this.rows = data.rows || [];
        this.loading = false;
        await this.service.render();
    }

    public async openDetail(row: any) {
        const { code, data } = await wiz.call("get", { id: row.id });
        if (code !== 200) {
            await this.service.alert.error(data?.message || "신청 건을 불러올 수 없습니다.");
            return;
        }
        this.selected = data.item;
        this.pendingAppForm = null;
        await this.service.render();
    }

    public closeDetail() {
        this.selected = null;
        this.pendingAppForm = null;
        this.service.render();
    }

    public async uploadAppForm() {
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        this.uploadingApp = true;
        await this.service.render();
        try {
            const fd = new FormData();
            fd.append('upload', files[0]);
            const res: any = await this.service.file.upload('/file/upload', fd);
            this.pendingAppForm = { url: res.url, name: files[0].name };
        } finally {
            this.uploadingApp = false;
            await this.service.render();
        }
    }

    public async confirmRequest() {
        if (!this.selected) return;
        if (!this.pendingAppForm && !this.selected.application_form) {
            await this.service.alert.error("먼저 시기변경 신청서 파일을 업로드해주세요.");
            return;
        }
        const ok = await this.service.alert.show({
            title: "확인",
            message: "조합원에게 시기변경 신청서를 발송 처리합니다. 진행하시겠습니까?",
            action: '확인하기',
            cancel: '취소',
            actionBtn: 'info'
        });
        if (!ok) return;
        const url = this.pendingAppForm ? this.pendingAppForm.url : '';
        const { code, data } = await wiz.call("confirm", { id: this.selected.id, application_form: url });
        if (code !== 200) {
            await this.service.alert.error(data?.message || "처리 실패");
            return;
        }
        await this.service.alert.success("신청서가 발송 처리되었습니다.");
        this.closeDetail();
        await this.load();
    }

    public async uploadCompletionDoc() {
        if (!this.selected) return;
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        this.uploadingComp = true;
        await this.service.render();
        try {
            const fd = new FormData();
            fd.append('upload', files[0]);
            const res: any = await this.service.file.upload('/file/upload', fd);
            const { code, data } = await wiz.call("upload_completion", {
                id: this.selected.id,
                completion_doc: res.url
            });
            if (code !== 200) {
                await this.service.alert.error(data?.message || "업로드 실패");
                return;
            }
            await this.service.alert.success("완료 처리되었습니다.");
            this.closeDetail();
            await this.load();
        } finally {
            this.uploadingComp = false;
            await this.service.render();
        }
    }

    public async manualStatus(s: string) {
        if (!this.selected) return;
        const { code, data } = await wiz.call("update_status", {
            id: this.selected.id,
            workflow_status: s
        });
        if (code !== 200) {
            await this.service.alert.error(data?.message || "변경 실패");
            return;
        }
        const { code: c2, data: d2 } = await wiz.call("get", { id: this.selected.id });
        if (c2 === 200) this.selected = d2.item;
        await this.load();
    }

    public async removeRow(row: any, ev: any) {
        ev.stopPropagation();
        const ok = await this.service.alert.show({
            title: "삭제",
            message: "해당 시기변경 신청을 삭제하시겠습니까?",
            action: '삭제',
            cancel: '취소',
            actionBtn: 'error',
            status: 'error'
        });
        if (!ok) return;
        const { code } = await wiz.call("remove", { id: row.id });
        if (code !== 200) {
            await this.service.alert.error("삭제 실패");
            return;
        }
        if (this.selected && this.selected.id === row.id) this.closeDetail();
        await this.load();
    }
}

export default PortalLpsysadminPeriodChangeListComponent;